import React from 'react';
import { downloadPNG } from '../../domain/io-provider';
import { useAppSelector } from '../../data/store';
import DownloadIcon from '../icons/DownloadIcon';

const DownloadPNGButton = () => {

    const artTextSVG = useAppSelector(store => store.root.artTextSVG);

    /**
     * download the result SVG
     */
    const downloadHandler = () => {
        downloadPNG(artTextSVG);
    };

    return (
        <button
            type="button"
            className="bg-blue-500 text-gray-100 rounded-full px-10 py-3 flex items-center justify-center whitespace-nowrap"
            onClick={ downloadHandler }><DownloadIcon /> <span className="ml-2">PNG</span></button>
    )
};

export default DownloadPNGButton;